import script from "./UInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UInput.vue?vue&type=script&setup=true&lang=js"

import "./UInput.vue?vue&type=style&index=0&id=3b89793a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b89793a"]])

export default __exports__